<app-header></app-header>
<main class="pages">
  <section class="gradient-light" id="planBanner">
    <div class="container pt-lg-5">
      <div class="row align-items-center">
        <div class="col-md-6">
          <h1 class="page-hero-title mt-3">
            Choose a plan that helps you achieve your goals!
          </h1>
          <h5 class="sub-text mt-4 mb-lg-3">
            Start your 7 days free trial now.
          </h5>
          <p>No credit card required.</p>
          <div class="mt-lg-4">
            <!-- <button class="btn btn-md px-lg-5 text-uppercase btn-outline-success mr-lg-2 ">Sign Up</button>
                        <button class="btn btn-md px-lg-5 text-uppercase btn-success">Try Now</button> -->
            <a
              (click)="tryNowPlan()"
              title=""
              class="btn btn-lg btn-success px-4 text-uppercase mr-lg-2"
            >
              Start Free Trial Now</a
            >
          </div>
        </div>
        <div class="col-md-6">
          <div class="page-banner-img">
            <img
              class="img-fluid w-100"
              alt="cviewsurvey pricing and plans"
              src="assets/pricing-new.svg"
            />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="pricing py-4 mt-5" id="pricing">
    <div class="section-body">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="plan-box mt-3">
              <table class="table table-responsive mb-0" id="tableLista">
                <tr>
                  <td class="border-0 px-0">
                    <table class="table table-bordered mb-0" id="planHeader">
                      <thead>
                        <tr>
                          <th
                            class="text-center"
                            style="vertical-align: middle"
                          >
                            <h1 class="plan mb-2">Plans</h1>
                            <div class="d-flex justify-content-center">
                              <div class="form-group">
                                <label class="col-form-label">Duration</label
                                ><br />
                                <div class="">
                                  <select
                                    class="form-control"
                                    name=""
                                    id=""
                                    (change)="
                                      planDurationChange($event.target.value)
                                    "
                                  >
                                    <!-- <option value="30">Monthly</option> -->
                                    <option value="30">Select duration</option>
                                    <option value="90">Quarterly</option>
                                    <option value="365">Yearly</option>
                                  </select>
                                </div>
                              </div>
                              <div class="form-group ml-3">
                                <label class="col-form-label">Users</label
                                ><br />
                                <div class="">
                                  <div class="pricing-option">
                                    <button
                                      class="decrement"
                                      (click)="decrement()"
                                    >
                                      -
                                    </button>
                                    <div class="input">{{ count }}</div>
                                    <button
                                      class="increment"
                                      (click)="increment()"
                                    >
                                      +
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <small class="text-center mt-2"
                              >* The price is exclusive of TAX as per
                              country</small
                            >
                          </th>
                          <th
                            *ngFor="
                              let plan of allPlan;
                              let planModuleWithService;
                              of: planModuleWithServices
                            "
                          >
                            <div
                              class="plan-info text-center"
                              *ngIf="plan.planSubTypeId == 1"
                            >
                              <h1 class="plan-title">{{ plan.name }}</h1>
                              <div class="plan-price text-center">
                                <!-- <select *ngIf="plan.currencyDetails.length > 0 " (change)="onCurrencyChange($event.target.value,plan.currencyDetails)" class="ml-auto mr-2 p-0 form-control" name="" id="" style="max-width: 40px;">
                                                                  <option *ngFor = " let currency of plan.currencyDetails" value="{{currency.currency_code}}">{{currency.currency_symbol}}</option>
                                                              </select> -->
                                <div
                                  *ngFor="
                                    let currencyDetail of plan.currencyDetails
                                  "
                                  class="font-weight-bold"
                                  style="
                                    font-size: 48px;
                                    font-weight: 500 !important;
                                  "
                                >
                                  {{ currencyDetail.currency.currency_symbol }}
                                </div>
                                <div
                                  *ngIf="plan.planSubTypeId == 1"
                                  class="text-center"
                                  style="font-size: 48px; font-weight: bolder"
                                >
                                  0
                                </div>
                              </div>
                              <small *ngIf="plan.planSubTypeId == 1"
                                >Price includes 1 Company Admin and 1
                                User/Device subscription.
                              </small>
                              <small *ngIf="plan.planSubTypeId == 2"
                                >Price includes Company Admin and
                                {{ count }} User/Device subscription.</small
                              >
                              <div class="action-button">
                                <!-- <a  class="text-uppercase btn btn-upgrade btn-sm px-5 py-2 disabled">Upgrade</a> -->
                                <!-- <a *ngIf="plan.planSubTypeId == 2" (click)="purchasePlan(plan.id,discountedPlanAmountINR(plan.amount, plan.discount) * count , discountedPlanAmountUSD(plan.amount, plan.discount) * count )" class="text-uppercase btn btn-upgrade btn-sm  px-5 py-2 ">Upgrade</a> -->
                                <a
                                  *ngIf="plan.planSubTypeId != 2"
                                  class="text-uppercase btn btn-upgrade btn-sm px-5 py-2"
                                  (click)="tryItNow()"
                                  >Try Now</a
                                >
                              </div>
                            </div>

                            <div
                              class="plan-info"
                              *ngIf="
                                plan.planSubTypeId == 2 &&
                                plan.currencyDetails.length > 0
                              "
                            >
                              <div>
                                <h1 class="plan-title">{{ plan.name }}</h1>
                                <div
                                  class="plan-price text-center"
                                  *ngIf="
                                    plan.planSubTypeId == 2 &&
                                    plan.name != 'Basic'
                                  "
                                >
                                  <!-- <select *ngIf="plan.currencyDetails.length > 0 " (change)="onCurrencyChange($event.target.value,plan.currencyDetails)" class="ml-auto mr-2 p-0 form-control" name="" id="" style="max-width: 40px;">
                                                                  <option *ngFor = " let currency of plan.currencyDetails" value="{{currency.currency_code}}">{{currency.currency_symbol}}</option>
                                                              </select> -->
                                  <div
                                    class="font-weight-bold"
                                    style="
                                      font-size: 48px;
                                      font-weight: 500 !important;
                                    "
                                  >
                                    {{
                                      plan.currencyDetails[0].currency
                                        .currency_symbol
                                    }}
                                  </div>
                                  <div
                                    *ngIf="plan.planSubTypeId == 2"
                                    class="text-center"
                                    style="font-size: 48px; font-weight: bolder"
                                  >
                                    {{
                                      discountedPlanAmount(
                                        plan.currencyDetails[0].amount,
                                        plan.currencyDetails[0].discount,
                                        plan.currencyDetails[0].tax
                                      ) * count
                                    }}
                                    <span style="font-size: 13px"
                                      >/{{
                                        selectedTimePeriodAfterPlanAmount
                                      }}</span
                                    >
                                  </div>
                                </div>
                                <div
                                  class="plan-price text-center"
                                  *ngIf="
                                    plan.planSubTypeId == 2 &&
                                    plan.name == 'Basic'
                                  "
                                >
                                  <!-- <select *ngIf="plan.currencyDetails.length > 0 " (change)="onCurrencyChange($event.target.value,plan.currencyDetails)" class="ml-auto mr-2 p-0 form-control" name="" id="" style="max-width: 40px;">
                                                                  <option *ngFor = " let currency of plan.currencyDetails" value="{{currency.currency_code}}">{{currency.currency_symbol}}</option>
                                                              </select> -->

                                  <!-- <div class="font-weight-bold" >
                                    {{
                                      plan.currencyDetails[0].currency
                                        .currency_symbol
                                    }}
                                  </div> -->
                                  <!-- <div
                                    *ngIf="plan.planSubTypeId == 2"
                                    class="text-center"
                                  >
                                    {{
                                      discountedPlanAmount(
                                        plan.currencyDetails[0].amount,
                                        plan.currencyDetails[0].discount,
                                        plan.currencyDetails[0].tax
                                      ) * count
                                    }}
                                    <span style="font-size:13px;">/{{selectedTimePeriodAfterPlanAmount}}</span> 
                                  </div> -->

                                  <img
                                    src="assets/freetag.jpg"
                                    *ngIf="
                                      plan.currencyDetails[0].currency
                                        .currency_symbol == '₹'
                                    "
                                    alt="free plan for a month"
                                  />
                                  <img
                                    src="assets/dollar.jpg"
                                    *ngIf="
                                      plan.currencyDetails[0].currency
                                        .currency_symbol == '$'
                                    "
                                    alt="free plan for a month"
                                  />
                                  <img
                                    src="assets/euro.jpg"
                                    *ngIf="
                                      plan.currencyDetails[0].currency
                                        .currency_symbol == '€'
                                    "
                                    alt="free plan for a month"
                                  />
                                  <img
                                    src="assets/AED.jpg"
                                    *ngIf="
                                      plan.currencyDetails[0].currency
                                        .currency_symbol == 'د.إ'
                                    "
                                    alt="free plan for a month"
                                  />
                                  <img
                                    src="assets/pounds.jpg"
                                    *ngIf="
                                      plan.currencyDetails[0].currency
                                        .currency_symbol == '£'
                                    "
                                    alt="free plan for a month"
                                  />
                                </div>
                                <marquee
                                  direction="left"
                                  *ngIf="
                                    plan.planSubTypeId == 2 &&
                                    plan.name == 'Basic'
                                  "
                                  style="
                                    font-family: Rajdhani, sans-serif;
                                    color: white;
                                  "
                                  bgcolor="red"
                                  scrolldelay="200"
                                  behavior="loop"
                                  >*Limited Period Offer</marquee
                                >

                                <small
                                  *ngIf="
                                    plan.planSubTypeId == 2 &&
                                    plan.name == 'Basic'
                                  "
                                >
                                  Price includes Company Admin and 1 User/Device
                                  subscription.
                                </small>
                                <small
                                  *ngIf="
                                    plan.planSubTypeId == 2 &&
                                    plan.name != 'Basic'
                                  "
                                >
                                  Price includes Company Admin and {{ count }}
                                  User/Device subscription.
                                </small>
                                <small
                                  class="discount text-danger" 
                                  *ngIf="
                                    plan.planSubTypeId == 2 &&
                                    plan.currencyDetails[0].discount > 0 &&
                                    selectedDuration != 365
                                  "
                                  >{{
                                    plan.currencyDetails[0].discount
                                  }}%</small
                                >
                                <small
                                  class="discount" style="display: none;"
                                  *ngIf="
                                    selectedDuration == 365 &&
                                    disYearly > 0 &&
                                    plan.planSubTypeId == 2 && 
                                    plan.name == 'Basic'
                                  "
                                  ></small
                                >
                                <small
                                  class="discount text-danger"
                                  *ngIf="
                                    selectedDuration == 365 &&
                                    disYearly > 0 &&
                                    plan.planSubTypeId == 2 && 
                                    plan.name != 'Basic'
                                  "
                                  >{{ disYearly }}%</small
                                >
                                <small
                                  class="discount text-danger"
                                  *ngIf="
                                    selectedDuration == 90 &&
                                    disQuarterly > 0 &&
                                    plan.planSubTypeId == 2
                                  "
                                  >{{ disQuarterly }}%</small
                                >
                                <!-- <small class="discount text-danger" *ngIf="plan.planSubTypeId == 2 && plan.currencyDetails[0].discount > 0" >{{plan.currencyDetails[0].discount}}%</small> -->
                                <div class="action-button">
                                  <!-- <a  class="text-uppercase btn btn-upgrade btn-sm px-5 py-2 disabled">Upgrade</a> -->
                                  <a
                                    *ngIf="
                                      plan.planSubTypeId == 2 &&
                                      plan.name != 'Basic'
                                    "
                                    (click)="
                                      purchasePlan(
                                        plan.id,
                                        plan.planSubTypeId,
                                        discountedPlanAmount(
                                          plan.currencyDetails[0].amount,
                                          plan.currencyDetails[0].discount,
                                          plan.currencyDetails[0].tax
                                        ) * count,
                                        plan.currencyDetails[0].currency
                                          .currency_code,
                                        plan.currencyDetails[0].tax
                                      )
                                    "
                                    class="text-uppercase btn btn-upgrade btn-sm px-5 py-2"
                                    >Buy now</a
                                  >
                                  <a
                                    *ngIf="
                                      plan.planSubTypeId == 2 &&
                                      plan.name == 'Basic'
                                    "
                                    (click)="
                                      purchasePlanThree(
                                        plan.id,
                                        plan.planSubTypeId,
                                        discountedPlanAmount(
                                          plan.currencyDetails[0].amount,
                                          plan.currencyDetails[0].discount,
                                          plan.currencyDetails[0].tax
                                        ) * count,
                                        plan.currencyDetails[0].currency
                                          .currency_code,
                                        plan.currencyDetails[0].tax
                                      )
                                    "
                                    class="text-uppercase btn btn-upgrade btn-sm px-5 py-2"
                                    >Try now</a
                                  >
                                  <a
                                    *ngIf="plan.planSubTypeId != 2"
                                    class="text-uppercase btn btn-upgrade btn-sm px-5 py-2 disabled"
                                    >Buy now</a
                                  >
                                </div>
                              </div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <thead>
                        <tr>
                          <td
                            [attr.colspan]="colspanDynamicLength"
                            class="text-center"
                          >
                            <h5 class="my-0">Compare Plan Services</h5>
                          </td>
                        </tr>
                      </thead>
                    </table>
                    <table
                      id="tableFixed"
                      class="sticky-plan-header table table-bordered"
                    >
                      <tr>
                        <td>
                          <h1 class="plan-services">Service details</h1>
                        </td>
                        <td
                          *ngFor="
                            let plan of allPlan;
                            let planModuleWithService;
                            of: planModuleWithServices
                          "
                        >
                          <div
                            class="plan-info text-center"
                            *ngIf="plan.planSubTypeId == 1"
                          >
                            <h1 class="plan-title">{{ plan.name }}</h1>
                          </div>

                          <div
                            class="plan-info"
                            *ngIf="
                              plan.planSubTypeId == 2 &&
                              plan.currencyDetails.length > 0
                            "
                          >
                            <h1 class="plan-title">{{ plan.name }}</h1>
                          </div>
                        </td>
                      </tr>
                    </table>
                    <table
                      class="table table-bordered mb-0"
                      *ngFor="
                        let planModuleWithService of planModuleWithServices;
                        let allServices;
                        of: allPublicServices;
                        let i;
                        of: index
                      "
                    >
                      <thead class="group-heading">
                        <tr>
                          <th
                            [attr.colspan]="colspanDynamicLength"
                            data-toggle="collapse"
                            [attr.data-target]="
                              '#' + 'PMS' + planModuleWithService.id
                            "
                            [attr.aria-expanded]="[
                              planModuleWithService.id == 1 ? true : true
                            ]"
                            [attr.aria-controls]="planModuleWithService.id"
                          >
                            <a
                              href="javascript:void(0)"
                              *ngIf="planModuleWithService.id != 7"
                              ><img
                                class="down-arrow"
                                src="assets/down-arrow.svg"
                                alt="arrow down"
                              />
                              {{ planModuleWithService.name }}</a
                            >
                            <a
                              href="javascript:void(0)"
                              *ngIf="planModuleWithService.id == 7"
                              ><img
                                class="down-arrow"
                                src="assets/down-arrow.svg"
                                alt="down arrow"
                              />
                              {{ planModuleWithService.name }}
                              <span class="text-danger">*</span>
                            </a>
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        [ngClass]="[
                          planModuleWithService.id == 1
                            ? 'collapse show'
                            : 'collapse show'
                        ]"
                        [attr.id]="'PMS' + planModuleWithService.id"
                      >
                        <tr
                          *ngFor="
                            let moduleWithService of planModuleWithService.module_services
                          "
                        >
                          <td
                            *ngIf="
                              moduleWithService.id != 9 &&
                              moduleWithService.id != 28 &&
                              moduleWithService.id != 35
                            "
                          >
                            <i
                              data-toggle="tooltip"
                              data-placement="right"
                              class="fa fa-info-circle mr-1"
                              title="{{ moduleWithService.description }}"
                              aria-hidden="true"
                            ></i>
                            <span>{{ moduleWithService.name }}</span>
                          </td>
                          <td *ngIf="moduleWithService.id == 28">
                            <i
                              data-toggle="tooltip"
                              data-placement="right"
                              class="fa fa-info-circle mr-1"
                              title="{{ moduleWithService.description }}"
                              aria-hidden="true"
                            ></i>
                            <span
                              >{{ moduleWithService.name
                              }}<span class="text-danger"> *</span></span
                            >
                          </td>
                          <td *ngIf="moduleWithService.id == 35">
                            <i
                              data-toggle="tooltip"
                              data-placement="right"
                              class="fa fa-info-circle mr-1"
                              title="{{ moduleWithService.description }}"
                              aria-hidden="true"
                            ></i>
                            <span
                              >{{ moduleWithService.name
                              }}<span class="text-danger"> *</span></span
                            >
                          </td>
                          <td class="p-0" *ngIf="moduleWithService.id == 9">
                            <table class="questionDetails">
                              <tr
                                *ngFor="let allQuestionType of allQuestionTypes"
                              >
                                <td>
                                  <i
                                    data-toggle="tooltip"
                                    data-placement="right"
                                    class="fa fa-info-circle mr-1"
                                    title="{{ allQuestionType.description }}"
                                    aria-hidden="true"
                                  ></i>
                                  <span>
                                    {{ allQuestionType.question_type }}
                                  </span>
                                </td>
                              </tr>
                            </table>
                          </td>
                          <td
                            class="p-0"
                            style="vertical-align: middle"
                            *ngFor="let plan of allPlan"
                          >
                            <span
                              *ngFor="
                                let plan_module_service of plan.plan_module_services
                              "
                            >
                              <span
                                *ngIf="
                                  plan_module_service.moduleServiceId ==
                                  moduleWithService.id
                                "
                                class="text-center"
                              >
                                <span
                                  *ngIf="
                                    plan_module_service.access_limit != 0 &&
                                    plan_module_service.unlimited != 1 &&
                                    plan_module_service.moduleServiceId != 24 &&
                                    plan_module_service.moduleServiceId != 13 &&
                                    plan_module_service.moduleServiceId != 14 &&
                                    plan_module_service.moduleServiceId != 28
                                  "
                                  >{{ plan_module_service.access_limit }}
                                </span>
                                <span
                                  *ngIf="
                                    plan_module_service.access_limit != 0 &&
                                    plan_module_service.unlimited != 1 &&
                                    plan_module_service.moduleServiceId == 24
                                  "
                                  >{{ plan_module_service.access_limit }}
                                  Responses Per Month
                                </span>
                                <span
                                  *ngIf="
                                    plan_module_service.access_limit != 0 &&
                                    plan_module_service.unlimited != 1 &&
                                    plan_module_service.moduleServiceId == 28
                                  "
                                  >{{ plan_module_service.access_limit }}
                                  Responses Per Month
                                </span>

                                <span
                                  *ngIf="
                                    plan_module_service.access_limit != 0 &&
                                    plan_module_service.unlimited != 1 &&
                                    plan_module_service.moduleServiceId == 13
                                  "
                                  >{{ plan_module_service.access_limit }}
                                  Messages Per Month
                                </span>
                                <span
                                  *ngIf="
                                    plan_module_service.access_limit != 0 &&
                                    plan_module_service.unlimited != 1 &&
                                    plan_module_service.moduleServiceId == 14
                                  "
                                  >{{ plan_module_service.access_limit }} User
                                  Per Device
                                </span>
                                <span
                                  *ngIf="
                                    plan_module_service.access_limit == 0 &&
                                    plan_module_service.unlimited == 1
                                  "
                                  >Unlimited</span
                                >
                                <span
                                  *ngIf="
                                    plan_module_service.access_limit == 0 &&
                                    plan_module_service.unlimited == 0 &&
                                    plan_module_service.moduleServiceId != 9
                                  "
                                >
                                  <span
                                    *ngIf="
                                      isAvailable(
                                        plan.plan_module_services,
                                        moduleWithService.id
                                      ) == true
                                    "
                                    class="active-service"
                                    ><img
                                      src="assets/check.svg"
                                      alt="check icon"
                                    />
                                  </span>
                                </span>
                                <span
                                  *ngIf="
                                    plan_module_service.moduleServiceId == 9
                                  "
                                >
                                  <table class="questions">
                                    <tr
                                      *ngFor="
                                        let allQuestionType of allQuestionTypes
                                      "
                                    >
                                      <td
                                        class="text-center active-service"
                                        *ngIf="
                                          isQuestionAvailable(
                                            plan_module_service.question_types,
                                            allQuestionType.id
                                          ) == true
                                        "
                                      >
                                        <img
                                          src="assets/check.svg"
                                          alt="check icon"
                                        />
                                      </td>
                                      <td
                                        class="text-center active-service"
                                        *ngIf="
                                          isQuestionAvailable(
                                            plan_module_service.question_types,
                                            allQuestionType.id
                                          ) == false
                                        "
                                      >
                                        <img
                                          src="assets/close.svg"
                                          alt="close icon"
                                        />
                                      </td>
                                    </tr>
                                  </table>
                                </span>
                              </span>
                            </span>
                            <span>
                              <span
                                *ngIf="
                                  isAvailable(
                                    plan.plan_module_services,
                                    moduleWithService.id
                                  ) == false
                                "
                                class="active-service"
                                ><img src="assets/close.svg" alt="close icon" />
                              </span>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-12 " style="padding-right: 0;">
            <div class="card shadow">
              <div class="card-header">
                <h6 class="mb-0 card-title">
                  <span class="text-danger">*</span>Disclaimer
                </h6>
              </div>
              <div class="card-body">
                <p>
                  <span class="text-danger">*</span> SMS service is only for
                  Indian Numbers.
                </p>
                <p><span class="text-danger">*</span> iOS App coming soon.</p>
                <p>
                  <span class="text-danger">*</span> To buy more Responses,
                  <a href="mailto:contact@cviewsurvey.com">contact us</a>.
                </p>
                <p>
                  <span class="text-danger">*</span> For Customised Plan,
                  <a href="mailto:contact@cviewsurvey.com">contact us</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="premium py-lg-5 bg-gray" id="enterprise">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <img
            style="max-width: 300px"
            src="assets/thinking.gif"
            alt="Confuse to choose right survey plan"
          />
          <h1 class="my-3">
            Using 20+ devices? Contact us for Enterprise Pricing.
          </h1>
          <div class="text-center">
            <a
              href="mailto:contact@cviewsurvey.com"
              class="btn btn-lg btn-success px-lg-5"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
<app-footer></app-footer>
